import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import { ActionWithPlayload } from '../../types';
import { ExperimentCountry } from './ExperimentCountry';

export type { ExperimentCountry as ExperimentCountryState };

type Action = ActionWithPlayload<
  ActionType.SET_EXPERIMENT_COUNTRY,
  ExperimentCountry
>;

export const initialState: ExperimentCountry = {
  experimentCountry: '',
};

const variablesReducer: Reducer<ExperimentCountry, Action> = (
  state: ExperimentCountry = initialState,
  action: Action,
) => {
  switch (action.type) {
    case ActionType.SET_EXPERIMENT_COUNTRY:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default variablesReducer;
